import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const ScribbleLine = ({ staggerIndex }) => {
  const pathRef = useRef(null);

  useGSAP(() => {
    const path = pathRef.current;
    if (path) {
      const length = path.getTotalLength();
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
      });
      gsap.to(path, {
        strokeDashoffset: 0,
        duration: 3,
        repeat: -1,
        ease: "power1.inOut",
        delay: staggerIndex * 1,
        yoyo: true,
      });
    }
  }, []);
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={214}
      height={91}
      viewBox="0 0 214 91"
      fill="none"
    >
      <path
        ref={pathRef}
        stroke="#A5D246"
        strokeWidth={12.905}
        d="M56.375-4.43c5.22 32.233 16.498 68.633 35.474 95.143 78.601 109.81 198.796-178.953 28.239-72.32C83.691 41.15 37.27 72.79 4.565 97.65"
      />
    </svg>
  );
};

export default ScribbleLine;
